import { Behavior } from '@dia-ui/abstract';

@Behavior('password')
export class Password {
  password: string;
  element : any;
  type: string;

  constructor(element) {
    this.element = element;
    this.password = '';
  }

  connectedCallback() {
    // force type password to hide it in initial state
    this.type = this.element.getAttribute('type');
    if (this.type !== 'password') {
      this.element.setAttribute('type', 'password');
    }

    let actionButton: HTMLButtonElement = document.createElement('button');
    actionButton.setAttribute('data-icon-only', '');

    actionButton.style.position = 'absolute';
    actionButton.style.width = '40px';
    actionButton.style.height = '100%';
    actionButton.style.right = '0';
    actionButton.style.appearance = 'none';
    actionButton.style.outline = 'none';
    actionButton.style.border = '0';
    actionButton.style.background = 'transparent';
    actionButton.style.cursor = 'pointer';

    let icon: HTMLElement = document.createElement('i');
    icon.setAttribute('data-icon-before', 'eye');

    // append icon to actionButton
    actionButton.append(icon);

    // append actionButton with icon to form control
    this.element.parentElement.append(actionButton);
    this.element.parentElement.querySelector('input').style.paddingRight = "50px";

    // toggle secret
    actionButton.addEventListener('click', (event: MouseEvent) => {
      event.preventDefault();

      if (this.element.getAttribute('type') === 'password') {
        actionButton.querySelector('i').setAttribute('data-icon-before', 'eye-slash');
        this.element.setAttribute('type', 'text');
        return;
      }

      actionButton.querySelector('i').setAttribute('data-icon-before', 'eye');
      this.element.setAttribute('type', 'password');
    });
  }
}
